import React, { Component } from 'react'
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import history from '../../routes/history'
import * as actionCreator from '../../redux/actions/data-action';
import { TaskSegment, getTaskTypeIdById } from '../../redux/actions/data-action';
import { Box } from '../../third-party-components/material-ui';
import NextButton from './../../assets/images/next@2x.png';

import { AssessmentContainer, AssessmentBody,
            AssessmentContent, AssessmentNavigationPrevious, AssessmentNavigationNext, AssessmentFooter,
            AssessmentContentHeader, AssessmentContentSection, AssessmentContentAction, AssessmentContentActionButton
} from './common';

const toPrevious = "/Demographic/Rater";

class AssessmentInstructionEnglishParent extends Component {
  componentDidMount()
  {
    window.history.pushState(null, null, history.location.href);
      window.onpopstate = function(event) {
          history.go(1);
      };
  }

    getFirstTaskTypeLink() {
        const { taskTypes } = this.props;
        const taskType = getTaskTypeIdById(taskTypes[0].id);

        var hasPractice = taskTypes[0].practice.length > 0

        return hasPractice ? `/Assessment/Tasks/${taskType.type}/${TaskSegment.INSTRUCTION}` : `/Assessment/Tasks/${taskType.type}/${TaskSegment.TASK}/1`;
    }

    handlePrevious() {
        history.push(toPrevious);
    }

    handleNext(nextLink) {
        history.push(nextLink);
    }

    render() {
      const version = parseInt(sessionStorage.getItem('temp-version-id'));

        return (
            <AssessmentContainer>
                <AssessmentContentHeader>Instructions</AssessmentContentHeader>
                <AssessmentBody>
                    <AssessmentContent className="assessment-content-introduction">
                        <AssessmentContentSection style={{textAlign: 'left'}}>
                            NOTE: Please keep your screen maximized during testing.
                            <br/>
                            <br/>
                            Here are some things parents might say about their children. Please read each item carefully. Indicate how true it is of your child or how often it happened in the <b>past month</b>. Think about whether:
                            <br/>
                            <br/>
                            <li>In the past month, this was <b><i>not true at all</i></b> about my child. It <b><i>never or rarely</i></b> happened.</li>
                            <li>In the past month, this was <b><i>just a little true</i></b> about my child. It happened <b><i>occasionally</i></b>.</li>
                            <li>In the past month, this was <b><i>pretty much true</i></b> about my child. It happened <b><i>often or quite a bit</i></b>.</li>
                            <li>In the past month, this was <b><i>completely true</i></b> about my child. It happened <b><i>very often or always</i></b>.</li>
                            <br/>
                            <br/>
                            Please click only one answer for each item. It is important to respond to every item. For items that you find difficult to answer, please give your best guess.
                            <br/>
                            <br/>
                            <Box>When you are ready to begin, click the forward arrow <b>{'>'}</b>.</Box>
                        </AssessmentContentSection>
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentContentAction>
                    <AssessmentContentActionButton styleType='arrows' onClick={this.handlePrevious}>{'<'}</AssessmentContentActionButton>
                    <AssessmentContentActionButton styleType='arrows' onClick={() => this.handleNext(this.getFirstTaskTypeLink())}>{'>'}</AssessmentContentActionButton>
                </AssessmentContentAction>
                <AssessmentFooter includeLogo={true}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

const mapStateToProps = (state, ownState) => (
    
    {
    taskTypes : state.data.tasks
})

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentInstructionEnglishParent));